import type { Components, Theme } from "@mui/material/styles";

export const MuiToggleButtonGroup: Components<Theme>["MuiToggleButtonGroup"] = {
  styleOverrides: {
    root: ({ theme }) => {
      const th = theme.vars || theme;
      const palette = th.palette;
      const shape = th.shape;
      const shadows = th.shadows;

      return {
        width: "fit-content",
        background:
          "light-dark(var(--mui-palette-neutral-lightest), var(--mui-palette-neutral-dark))",
        padding: "2px",
        borderRadius: (shape.borderRadius as number) * 2,
        fontSize: "14px",
        overflow: "hidden",
        whiteSpace: "nowrap",
        lineHeight: "1.3rem",

        "& .MuiButtonBase-root": {
          lineHeight: "inherit",
          padding: `0.25em 1.4em`,
          borderRadius: "inherit",
          border: "none",
          textTransform: "capitalize",
          fontSize: "inherit",

          "&.MuiToggleButton-sizeSmall": {
            padding: `0.2em 1em`,
          },

          "&.MuiToggleButton-sizeXsmall": {
            padding: `0em 0.8em`,
            fontSize: "12px",
          },

          "&:hover": {
            background: "none",
            color: "light-dark(var(--mui-palette-text-dark), inherit)",
          },

          "&.Mui-selected": {
            color:
              "light-dark(var(--mui-palette-text-dark), var(--mui-palette-text-primary))",
            background: palette.background.paper,
            boxShadow: shadows[4],
            pointerEvents: "none",
          },

          ".MuiTouchRipple-root": {
            display: "none",
          },
        },
      };
    },
  },
  variants: [
    {
      props: { size: "xsmall" },
      style: {
        fontSize: "12px",
      },
    },
  ],
};
